import React, { Component } from "react";
import { Accessor, ColorX, GFunc, IconX, ZFunc } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XIconButton, XText } from "IZOX/_X";
import { observer } from "mobx-react";
import htmlParser from "html-react-parser";
import OperBar from "IZOX/BLOCKS/Libs/OperBar/OperBar";
import _ from "lodash";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ZDialog extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ZDialog.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _onConfirm = async () => {
    let {content} = this.props;
    let {onConfirm, autoClose} = content ?? {};
    if(onConfirm && _.isFunction(onConfirm)){
      try {
        GFunc.SetAskLoading(true);
        let res = await onConfirm();
        if (autoClose){
          if(!res || res.Success === undefined || (res && res.Success)){
            GFunc.CloseAsk();
          }
        }
      }finally{
        GFunc.SetAskLoading(false);
      }
      
    }else{
      GFunc.CloseAsk();
    }
  }

  _onCancel = async () => {
    let {content} = this.props;
    let {onCancel} = content ?? {};
    if(onCancel && _.isFunction(onCancel)){
      GFunc.SetAskLoading(true);
      try{
        await onCancel();
      }finally{
        GFunc.SetAskLoading(false);
      }
    }
    GFunc.CloseAsk();
  }

  renderTitle(){
    let {content} = this.props;
    let title = content?.title;
    title = ZFunc.IfFuncExec(title);
    if(_.isString(title)){
      title = htmlParser(title);
    }

    return (
      <HStack style={{
        background: SysConfig?.Dialog?.Title?.bgColor ?? ColorX.CSS("cmBlue", 0.07)
      }}>
        <XText 
          style={{
            fontSize: SysConfig?.Dialog?.Title?.fontSize ?? 16,
            fontFamily: SysConfig?.Dialog?.Title?.fontFamily,
            fontWeight: "bold",
            textAlign: "left",
            color: SysConfig?.Dialog?.Title?.color ?? ColorX.CSS("cmBlue"),
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 5,
            paddingBottom: 5,
          }}>
          {title}
        </XText>
        <Spacer/>
        {content.showCloseIcon && 
          <XIconButton onClick={GFunc.CloseAsk} padding={5}>
            {IconX.Get("ant", "close", 15, ColorX.CSS("red"))}
          </XIconButton>
        }
      </HStack>
    );
  }

  renderMsg(){
    let {content} = this.props;
    let message = content?.message;
    message = ZFunc.IfFuncExec(message);

    if(_.isString(message)){
      message = htmlParser(message);
    }

    return (
      <VStack alignItems="flex-start" width={"100%"}>
        <XText style={{
          fontFamily: SysConfig?.Dialog?.Content?.fontFamily ?? "Arial", 
          whiteSpace: "pre-wrap",
          fontSize: SysConfig?.Dialog?.Content?.fontSize ?? 14,
          textAlign: "left",
          paddingLeft: 15,
          paddingRight: 15,
          paddingTop: 15,
          paddingBottom: 15,
          width: "100%"
        }}>
          {message}
        </XText>
      </VStack>
    );
  }

  render(){
    let {content} = this.props;
    let {inner, buttons, isLoading} = content ?? {};
    return (
      <VStack style={{
        background: SysConfig?.Dialog?.Content?.bgColor ?? ColorX.CSS("aliceblue"),
        borderRadius: 15,
        boxShadow: `1px 1px 2px 2px ${ColorX.CSS("aliceblue", 0.5)}`,
        minWidth: 300,
        maxWidth: 420,
        color: ColorX.CSS("darkBox")
      }}>
        <VStack width="100%" style={{minHeight: SysConfig?.Dialog?.Content?.minHeight}}>
          {this.renderTitle()}
          {this.renderMsg()}
          <Spacer/>
          
          {/* <LinearProgress style={{width: "100%"}}
            sx={{
              opacity: GState.ask.isLoading ? 1 : 0.0
            }}/> */}
          {inner && inner(isLoading)}
          {buttons && buttons.length > 0 &&
          <OperBar
            disabled={isLoading}
            size={SysConfig?.Dialog?.Button?.fontSize ?? 14}
            buttons={buttons}
            onConfirm={this._onConfirm}
            onCancel={this._onCancel}
            />}
        </VStack>
      </VStack>
    );
  }

}

export default observer(ZDialog);
